// extracted by mini-css-extract-plugin
export default {"wrapper":"AddOrganization_wrapper__YSof+","form":"AddOrganization_form__cO5Pj"};